// extracted by mini-css-extract-plugin
export default {"outlinedBtn":"CustomButton_outlinedBtn__YgpYx","textBtn":"CustomButton_textBtn__7T8Dv"};